import { atom } from "jotai";
import { DEFAULT_PRODUCT_TYPE } from "./product-types";

export const selectedProductTypeAtom = atom<string>(DEFAULT_PRODUCT_TYPE);

export const selectedStatusesAtom = atom<string[]>([]);

export const searchTextAtom = atom<string>('');

export const currentDronesListPageAtom = atom<number>(0);

export const inventarizationModeAtom = atom<boolean>(false);

export const selectedDroneModelsAtom = atom<string[]>([]);

export const availableDroneModelsAtom = atom<string[]>([]);

// Template filtering
export const selectedTemplatesAtom = atom<string[]>([]);
export const availableTemplatesAtom = atom<Array<{label: string, value: string}>>([]); // Store template options

export const availableStatusesListAtom = atom([
  { label: "0 - Draft", value: "draft" },
  { label: "1 - Complectation", value: "complectation" },
  { label: "2 - Waiting components", value: "waiting" },
  { label: "3 - To mount frame", value: "1 - Mount frame" },
  { label: "4 - To mount motors", value: "2 - Mount motors" },
  { label: "5 - To mount Parts", value: "3 - To mount Parts" },
  { label: "6 - To solder", value: "4 - To solder" },
  { label: "7 - Soldering", value: "4.1 - Soldering" },
  { label: "8 - To test", value: "5 - To test" },
  { label: "8.1 - To fix", value: "To fix" },
  { label: "9 - To final montage", value: "6 - To final montage" },
  { label: "10 - To final test", value: "7 - To final test" },
  { label: "11 - Ready", value: "ready" },
  { label: "12 - On the way", value: "inProgress" },
  { label: "To clarify", value: "to clarify" },
  { label: "Later", value: "Later" },
  { label: "Have problems", value: "have problems" },
  { label: "Sent", value: "sent" },
]);

export const pageSizeAtom = atom<number>(10);
export const currentPageAtom = atom<number>(0);

export const showSentAtom = atom<boolean>(false);
